import React from 'react';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import {useMyAccount} from '../../../../../../data/hooks/sessionHooks';

/**
 * Renders the step to add a photo to the user profile
 *
 * @return {JSX.Element} The rendered StepPhoto component.
 */
function StepPhoto() {
    const i18n = useI18n(),
        user = useMyAccount(),
        userHasImage = !!user.image_url;

    return (
        <StartNetworkingStep href="./photo" done={userHasImage} complete={userHasImage}>
            {i18n['start.upload_photo']}
        </StartNetworkingStep>
    );
}

export default StepPhoto;
